import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUCER_BASE_NAME } from '#base/constants';
import { StateBaseType } from '#base/types';

const initialState: StateBaseType = {
  isContentHeightAuto: false,
};

const sliceBase = createSlice({
  name: REDUCER_BASE_NAME,
  initialState,
  reducers: {
    setIsContentHeightAuto: (state, action: PayloadAction<boolean>) => {
      state.isContentHeightAuto = action.payload;
    },
  },
});

const reducerBase = sliceBase.reducer;

const { setIsContentHeightAuto } = sliceBase.actions;

export {
  reducerBase,
  setIsContentHeightAuto,
};
